import ApisServiceApp from '@/apis/ApisServiceApp'
import { apiUrl } from '@/config'
import { tokenStorage } from '@/services/tokenStorage'

export const blobResponseConfig = { responseType: 'blob' as const }

export const parseBlobErrorIfJson = async (blob: Blob): Promise<never> => {
  const text = await blob.text()
  try {
    const j = JSON.parse(text) as { message?: string }
    throw new Error(j?.message || 'Yêu cầu thất bại')
  } catch (e) {
    if (e instanceof SyntaxError) throw new Error(text.trim().slice(0, 240) || 'Yêu cầu thất bại')
    throw e
  }
}

export const ensureExcelBlob = async (blob: Blob): Promise<Blob> => {
  if (blob.type && blob.type.includes('application/json')) await parseBlobErrorIfJson(blob)
  return blob
}

export const resolveApiBase = (): string => {
  const fromEnv = (apiUrl || '').replace(/\/$/, '')
  const fromAxios = String(ApisServiceApp.defaults.baseURL || '').replace(/\/$/, '')
  return fromEnv || fromAxios
}

export const fetchExcelBlob = async (request: () => Promise<unknown>): Promise<Blob> => {
  const blob = (await request()) as Blob
  return ensureExcelBlob(blob)
}

export const postMultipartFile = async (
  path: string,
  file: File,
  extraFields?: Record<string, string | boolean | undefined>,
): Promise<unknown> => {
  const base = resolveApiBase()
  if (!base) throw new Error('Chưa cấu hình API base URL')

  const formData = new FormData()
  formData.append('file', file)
  if (extraFields) {
    Object.entries(extraFields).forEach(([key, value]) => {
      if (value === undefined) return
      formData.append(key, typeof value === 'boolean' ? String(value) : value)
    })
  }

  const token = tokenStorage.getAccessToken()
  const res = await fetch(`${base}${path}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    body: formData,
  })

  if (!res.ok) {
    let msg = `HTTP ${res.status}`
    try {
      const j = (await res.json()) as { message?: string }
      if (j?.message) msg = j.message
    } catch {
      // ignore
    }
    throw new Error(msg)
  }

  const text = await res.text()
  if (!text) return {}
  try {
    return JSON.parse(text) as unknown
  } catch {
    return {}
  }
}
